import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { ActiveUserData } from 'src/types/combinedUserData';
import { _mockUsersData } from './getAllUsers';

export interface GetAllUsersResponse {
  success: boolean;
  users: ActiveUserData[];
}

const getAllUsersByPermission: QueryFunction<
  GetAllUsersResponse,
  ['/shared/users/by-permission', string]
> = async ({ queryKey }) => {
  if (isMockServices()) return await mock(_mockUsersData);
  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GetAllUsersResponse>(
    `/shared/users/permission/${queryKey[1]}`,
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data;
  throw new Error('Failed to fetch users');
};

export default getAllUsersByPermission;
